import { Container } from "@mui/material";
import Usuarios from "../../componentes/RolesUsuarios/Usuarios";
import { useContext, useEffect, useState } from "react";
import { CasUserContext } from "../../services/casUserContext";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import UsuarioService from "../../services/UsuarioService";

const usuarioService = new UsuarioService();

export const UsuariosPage:React.FC<{}> =() =>{
    const casUserContext = useContext(CasUserContext);
    const userData = casUserContext.userData;
    const [auth,setAuth] = useState(true);

    //Seccion Carga
    useEffect(() => {
        const flag = usuarioService.authorizedByRol(142,userData.roles) || usuarioService.authorizedByRol(144,userData.roles)|| usuarioService.authorizedByRol(147,userData.roles);
        setAuth(flag);
    },[userData]);

    return(
        <Container sx={{mt:4}}>
            {/* <Usuarios pesta={1} /> */}
            {auth ? 
            <Usuarios/>
            :
            <UnauthorizedPage />
            }
        </Container>
        
    );
}